var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14566 2.94905C5.72337 2.94905 2.94905 5.72337 2.94905 9.14566C2.94905 12.568 5.72337 15.3423 9.14566 15.3423C10.8191 15.3423 12.3375 14.679 13.4525 13.6009C13.4725 13.5731 13.4951 13.5464 13.5201 13.5214C13.5452 13.4963 13.5719 13.4737 13.5998 13.4536C14.6785 12.3386 15.3423 10.8196 15.3423 9.14566C15.3423 5.72337 12.568 2.94905 9.14566 2.94905ZM14.8672 13.9619C15.9637 12.6608 16.6243 10.9804 16.6243 9.14566C16.6243 5.01531 13.276 1.66699 9.14566 1.66699C5.01531 1.66699 1.66699 5.01531 1.66699 9.14566C1.66699 13.276 5.01531 16.6243 9.14566 16.6243C10.9797 16.6243 12.6596 15.9641 13.9606 14.8684L17.2381 18.1459C17.4884 18.3962 17.8943 18.3962 18.1447 18.1459C18.395 17.8956 18.395 17.4897 18.1447 17.2394L14.8672 13.9619Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon3);
export default __webpack_public_path__ + "static/media/search-icon-3.5a298b1d1922b6d21c2fa91e73babef9.svg";
export { ForwardRef as ReactComponent };